import { CompanyID } from '@blisspointmedia/bpm-types/dist/UserAdmin';
import { SelectorOption } from '@Components/ModalEditWidget/modal-edit-constants';

export const ALL_COMPANIES_OPTION: SelectorOption = { label: 'All Companies', value: 'all' };

/**
 * Company options for the user-admin selector.
 *
 * Each company is limited to those the current user can access themselves, so a non-admin internal
 * user can't grant access to a company they can't see. "All Companies" is offered only when the
 * backend says the caller holds 'all' (`callerHasAll`).
 */
export const getCompanyOptions = (
  companies: CompanyID[],
  accessibleCompanyCids: Set<string>,
  callerHasAll: boolean | undefined
): SelectorOption[] => {
  const companyOptions = companies
    .filter(({ cid }) => accessibleCompanyCids.has(cid))
    .map(({ cid }) => ({ label: cid, value: cid }));

  return callerHasAll ? [ALL_COMPANIES_OPTION, ...companyOptions] : companyOptions;
};
